// removed by extract-text-webpack-plugin
module.exports = {"vpCameraButtonsContainer":"vpCameraButtonsContainer___kMUgC","vpStartRecordingButton":"vpStartRecordingButton___3gPGp","vpStopRecordingButton":"vpStopRecordingButton___1xVeL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CameraRecord/CameraRecord.module.less
// module id = 3473
// module chunks = 29